import { Trip } from './../classes.js';
import { notification } from './../function/notification.js';
import { start_loading, end_loading } from './../function/common.js';

export class cExpenseManager {
	constructor() {
		
		$('body').on('click', '.expense_manager--open', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.open();
		})
		
		$('body').on('click', '.expense_manager--close', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.close();
		})
		
		$('body').on('click', '.expense_add--open', {obj: this}, function(e){
			e.preventDefault();
			e.data.obj.set_add();
			e.data.obj.add_open();
		})
		
		$('body').on('click', '[data-expense]', {obj: this}, function(e){
			e.preventDefault();
			
			let ex = $(this).attr('data-expense');
			const index = Trip.expenses.findIndex(expense => expense.id == ex);
			
			e.data.obj.set_add(index);
			e.data.obj.add_open();
		})
		
		$('body').on('click', '.expense_add--close', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.add_close();
		})
		
		$('body').on('click', '#ex_submit', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.add_expense();
		})
		
		$('body').on('click', '#ex_delete', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.delete_expense();
		})
	}
	
	
	open(){
		$('#expense_manager').css("display", "flex").hide().fadeIn(200);
		this.set_expenses(Trip.expenses);
	}
	
	
	close(){
		//close the display
		$('#expense_manager').fadeOut(200);
	}
	
	add_open(){
		$('#expense_add').css("display", "flex").hide().fadeIn(200);
	}
	
	
	add_close(){
		//close the display
		$('#expense_add').fadeOut(200);
	}
	
	
	
	set_expenses(expenses){
		//set vars and display for this
		$('#expense_table tbody').html('');
		let total = 0;
		
		if(Object.entries(expenses).length > 0){
			for (const [i, expense] of Object.entries(expenses)) {
				total = total + parseFloat(expense.amount_per_guest);
				
				$('#expense_table tbody').append(`
					<tr data-expense="${expense.id}">
						<td>
							${expense.name}
						</td>
						<td>
							$${expense.amount_per_guest}
						</td>
						<td>
							${expense.element_name == null ? 'General Trip' : expense.element_name}
						</td>
					</tr>
				`)
			}
			
			$('#expense_table tbody').append(`
				<tr class="strong" data-expense="total">
					<td>
						Total
					</td>
					<td>
						$${total.toFixed(2)}
					</td>
					<td>
						
					</td>
				</tr>
			`)
			
			Trip.content.trip.expenses_total = total.toFixed(2);
			
		}else{
			$('#expense_table tbody').append(`
				<tr>
					<td colspan="3" style="text-align:center;">No Expenses added at this time.</td>
				</tr>
			`)
		}
	}
	
	set_add(expense = null){
		$(`#expense_add__body #ex_associate option`).attr('selected', false);
		$('#ex_delete').hide();
		$('#expense_add__body #ex_submit').removeClass('update');
		
		if(expense == null){
			$('#expense_add__body h3').text('Add Expense');
			$('#expense_add__body #ex_id').val('');
			$('#expense_add__body #ex_amount').val('');
			$('#expense_add__body #ex_name').val('');
			$('#expense_add__body #ex_count').val(1);
			$(`#expense_add__body #ex_associate option[value="trip"]`).attr('selected', true);
			$('#expense_add__body #ex_submit').text('Add & Close');
			$('#expense_add__body .form__row').last();
		}else{
			const ex = Trip.expenses[expense];
			$('#expense_add__body h3').text(`Update Expense: ${ex.name}`);
			$('#expense_add__body #ex_id').val(ex.id);
			$('#expense_add__body #ex_amount').val(ex.amount);
			$('#expense_add__body #ex_name').val(ex.name);
			$('#expense_add__body #ex_count').val(ex.guest_count);
			$(`#expense_add__body #ex_associate option[value="${ex.element_id == null ? 'trip' : ex.element_id}"]`).attr('selected', true);
			$('#expense_add__body #ex_submit').text('Update & Close');
			$('#expense_add__body #ex_submit').addClass('update');
			$('#ex_delete').show();
		}
	}
	
	async add_expense(){
		//create the form to upload the expense
		let ex = document.querySelector('#ex_form');
		let expense_form = new FormData(ex);
		expense_form.append('trip_id', $('#trip_id').val());
		let path = '/api/expense/create';
		let notify = 'Adding';
		
		if($('#expense_add__body #ex_submit').hasClass('update') && expense_form.get('ex_id') > 0){
			path = '/api/expense/update';
			notify = 'Updating';
		}
		
		start_loading(notify + ' Expense...');
		
		try {
			let response = await fetch(path, {
				method: 'POST',
				body: expense_form
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			console.log(result);
			if(result.error){
				//error
				end_loading('Error '+ notify +' Expense');
			}else{
				/**
					New Expense added, update the general expense display
				**/
				
				let ex = {
					'id': parseInt(result.data.id)
					, 'name': expense_form.get('ex_name')
					, 'amount': expense_form.get('ex_amount')
					, 'guest_count': expense_form.get('ex_count')
					, 'amount_per_guest': (expense_form.get('ex_amount')/expense_form.get('ex_count')).toFixed(2)
					, 'element_id': parseInt(expense_form.get('ex_associate'))
					, 'element_name': expense_form.get('ex_associate') == 'trip' ? null : $(`#ex_associate option[value="${expense_form.get('ex_associate')}"]`).text()
				}
				
				if($('#expense_add__body #ex_submit').hasClass('update') && expense_form.get('ex_id') > 0){
					const index = Trip.expenses.findIndex(expense => expense.id == expense_form.get('ex_id'));
					Trip.expenses[index] = ex;
				}else{
					Trip.expenses.push(ex);
				}
				Trip.expenses = Object.values(Trip.expenses);
				
				this.set_expenses(Trip.expenses);
				end_loading('Expense Complete');
				this.add_close();
			}
			
		} catch (error) {
			console.error('Error ***', error);
			end_loading('Error '+ notify +' Expense');
		}
	}
	
	
	async delete_expense(){
		//create the form to upload the expense
		let ex = document.querySelector('#ex_form');
		let expense_form = new FormData(ex);
		expense_form.append('trip_id', $('#trip_id').val());
		
		start_loading('Removing Expense...');
		
		try {
			let response = await fetch('/api/expense/delete', {
				method: 'POST',
				body: expense_form
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			console.log(result);
			if(result.error){
				//error
				end_loading('Error Removing Expense');
			}else{
				/**
					Expense removed, update the general expense display
				**/
				end_loading('Expense Removed');
				
				const index = Trip.expenses.findIndex(expense => expense.id == expense_form.get('ex_id'));
				Trip.expenses.splice(index, 1);
				Trip.expenses = Object.values(Trip.expenses);
				
				this.set_expenses(Trip.expenses);
				this.add_close();
			}
			
		} catch (error) {
			console.error('Error ***', error);
			end_loading('Error Removing Expense');
		}
	}
}